import { z } from 'zod';

import { unique } from '@vestigas/utils';

export const zodUsersBulkPayloadSchema = z.object({
  ids: z.tuple([z.uuid()], z.uuid()).transform((ids) => unique(ids).toSorted()),
  includeCompanyInformation: z.boolean().optional(),
});
